import React from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import Spinner from "js/components/Shared/Spinner";
import { Redirect } from "react-router-dom";
import { isEmpty } from "lodash";

const Privacidad = props => {
  const { privacidad } = props;

  if (privacidad === undefined)
    return <Spinner thickness={7} color="inherit" variant="indeterminate" />;
  else if (isEmpty(privacidad)) {
    return <Redirect to="/landing" />;
  }
  return <div>{Parser(privacidad)}</div>;
};

Privacidad.propTypes = {
  classes: PropTypes.object,
  privacidad: PropTypes.string
};

Privacidad.defaultProps = {};

Privacidad.displayName = "Privacidad";

export default Privacidad;
